import AirTracker, { Config, Environment } from '@airwallex/airtracker';
import pkg from '../../package.json';
import { getPageEnvByHost } from './environment';

const pageEnv = getPageEnvByHost();

const config: Config = {
  appName: 'ext_billing_hosted_invoice',
  appVersion: `v${pkg.version}`,
  env: (pageEnv === 'sandbox' ? 'preview' : pageEnv) as Environment,
  enableErrorMonitoring: true,
  assetSpeedMonitoringWhiteList: [/\.airwallex\.com\//],
};

export const airTracker = new AirTracker({ config });
